const Footer = () => {
    return (
        <footer>
            <div>
                Developed by <a href="https://shoaibkhalid.ca">Shoaib Khalid</a>
            </div>
    </footer>
    )
}

export default Footer;